import { z } from "zod";

import { DbEnum } from "../../generated/prisma-enums";
import { enumReadSchema } from "../../shared/core/enum-read.schema";

/**
 * Whether a custom domain is a zone apex or a name under one. Sourced from the
 * Prisma enum so the contract cannot drift from the column; see
 * `VibeAppDomainKind` in the schema for why it is stored rather than derived.
 */
export const VibeAppDomainKindSchema = z.enum(DbEnum.VIBE_APP_DOMAIN_KIND_VALUES);

/** `VibeAppDomainKindSchema` as a reader parses it: a value this build does not list reads as unlisted. */
export const VibeAppDomainKindReadSchema = enumReadSchema(DbEnum.VIBE_APP_DOMAIN_KIND_VALUES);
export type VibeAppDomainKind = z.infer<typeof VibeAppDomainKindSchema>;

/**
 * Lifecycle of a custom domain. Sourced from the Prisma enum; see
 * `VibeAppDomainStatus` in the schema — the edge's certificate decision is read
 * off this value, so it is an authorization state, not a label.
 */
export const VibeAppDomainStatusSchema = z.enum(DbEnum.VIBE_APP_DOMAIN_STATUS_VALUES);

/** `VibeAppDomainStatusSchema` as a reader parses it: a value this build does not list reads as unlisted. */
export const VibeAppDomainStatusReadSchema = enumReadSchema(DbEnum.VIBE_APP_DOMAIN_STATUS_VALUES);
export type VibeAppDomainStatus = z.infer<typeof VibeAppDomainStatusSchema>;
